import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SendingService } from 'app/modules/fuse/services/sending.service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';

@Component({
    selector: 'app-send-citations',
    templateUrl: './send-citations.component.html',
    styleUrls: ['./send-citations.component.scss'],
    standalone: false
})
export class SendCitationsComponent implements OnInit {

  public citationForm: UntypedFormGroup;
  public admintrativeUsers = [];
  public SelectedAdministrativeUser: any;
  selectedCompanyName: string;

  constructor(
    private dialogRef: MatDialogRef<SendCitationsComponent>,
    public _dialog: MatDialog,
    private _sharedService: SharedService,
    private _sendingService: SendingService,
    private _fb: UntypedFormBuilder,
    private _fileExportService: FileExportService,
    @Inject(MAT_DIALOG_DATA) private users
  ) {
    this.admintrativeUsers = users.admintrativeUsers
    this.selectedCompanyName = localStorage.getItem("SelectedCompanyName");
    this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');
  }

  ngOnInit(): void {
    this.createReportsForm();
  }

  createReportsForm() {
    this.citationForm = this._fb.group({
      SelectedAdministrativeUser: [''],
      SelectedCompanyId: [this._sendingService.selectedCompanyId]
    });
  }

  public onAdminUserChange(event: any) {
    this.SelectedAdministrativeUser = event.value;
  }

  onSubmit(): void {
    this.citationForm.markAllAsTouched()
    if (this.citationForm.valid) {
      // download zip
      this.downloadCitationZip(this.citationForm.value);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }


  /**
   * Download citation zip file for the given company
   */
  private downloadCitationZip(data) {

    this._sendingService
      .getGetCitationZip(data)
      .subscribe(res => {
        if (res.code === 0) {

          // if result is null, no data
          if (res.result == null) {
            this._sharedService.ShowSnackBar('No hay citaciones');
          } else {

            const { zipFile, bajasIds, tareasIds } = res.result;

            // download file
            this._fileExportService.DownloadFile(zipFile.file, zipFile.fileName);
            this.close();
            // ask for clearning process after citation
            this.cleanAfterCitation(bajasIds, tareasIds);

          }

        } else {
          if (res.message)
            console.error("Server Error: " + res.message);
          this._sharedService.ShowSnackBar('Lo siento, el proceso falló');
        }
      }, err => {
        console.error(err);
        this._sharedService.ShowSnackBar('Lo siento, el proceso falló');
      });
  }


  /**
   * If user wants to clean tasks and leaves after downloading citation, clean them
   */
  private cleanAfterCitation(bajasIds: number[], tareasIds: number[]) {

    // ask for confirmation
    const dialogData = new ConfirmDialogModel("¿Ha recibido el fichero zip con las citaciones? Al confirmar se crearán las actuaciones de citación, se quitarán las tareas de citar, y se crearán las tareas de acuse de recibo correspondientes.", "");
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    // handle after close
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this._sendingService
          .cleanAfterCitation(bajasIds, tareasIds)
          .subscribe(res => {

            if (res.code === 0) {
              this._sharedService.ShowSnackBar('proceso completado con éxito');
            } else {
              if (res.message)
                console.error("Server Error: " + res.message);
              this._sharedService.ShowSnackBar('Lo siento, el proceso falló');
            }

          }, err => {
            console.error(err);
            this._sharedService.ShowSnackBar('Lo siento, el proceso falló');
          });
      }
    });

  }
  //#endregion


}

